<template>
  <router-view />
</template>
<script>

export default {
  name: 'EmptyLayout',
  created() {
    document.title = 'MELON'
  }
}
</script>
